import script from "./ActivitiesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivitiesList.vue?vue&type=script&setup=true&lang=js"

import "./ActivitiesList.vue?vue&type=style&index=0&id=609a6fa9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609a6fa9"]])

export default __exports__